import store from 'dashboard/store';

const isToolEnabled = () => !import.meta.env.PROD;

const canAccessTool = () => {
  if (!isToolEnabled()) {
    return false;
  }

  return store.getters.getCurrentRole === 'administrator';
};

const registerSidebarMenuHook = PluginSystem => {
  PluginSystem.registerHook('sidebar:menu-items', payload => {
    if (!canAccessTool() || !payload?.items || !Array.isArray(payload.items)) {
      return payload;
    }

    const settingsGroup = payload.items.find(item => item.name === 'Settings');
    if (!settingsGroup || !Array.isArray(settingsGroup.children)) {
      return payload;
    }

    const exists = settingsGroup.children.some(
      child => child.name === 'Settings Development Cache'
    );

    if (!exists) {
      settingsGroup.children.push({
        name: 'Settings Development Cache',
        label: payload.t?.('DEV_CACHE_TOOL.SIDEBAR_LABEL') || 'Cache',
        icon: 'i-lucide-trash-2',
        activeOn: ['settings_dev_cache_tool'],
        to: payload.accountScopedRoute
          ? payload.accountScopedRoute('settings_dev_cache_tool')
          : {
              name: 'settings_dev_cache_tool',
              params: { accountId: payload.context?.accountId },
            },
      });
    }

    return payload;
  });
};

export function install(_app, { PluginSystem } = {}) {
  if (!PluginSystem || !isToolEnabled()) {
    return;
  }

  registerSidebarMenuHook(PluginSystem);
  window.dispatchEvent(new Event('chatwoot:sidebar:refresh'));
}

export default { install };
